export const cognitoParamsError = () =>
  new Error("cognito-invalid-params: idToken and redirectURI should be filled");

export const cognitoTokenResError = () =>
  new Error("cognito-token-res-error: failed to obtain token (response is empty)");

export const cognitoTokenError = (code: number) =>
  new Error(`cognito-token-error: failed to obtain token (status=${code})`);
